import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AdminModule } from '@/store/modules/admin';
import AdminDashboard from './admin/index.vue';
import ExecutiveDashboard from './executive/index.vue';
import AgentDashboard from './agent/index.vue';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.currentRole = 'admin-dashboard';
  }
  get roles() {
    return AdminModule.roles;
  }
  activated() {
    if (this.roles.includes('executive')) {
      this.currentRole = 'executive-dashboard';
    } else if (this.roles.includes('Agent')) {
      this.currentRole = 'agent-dashboard';
    }
  }
};
default_1 = __decorate([Component({
  name: 'Dashboard',
  components: {
    AdminDashboard,
    ExecutiveDashboard,
    AgentDashboard
  }
})], default_1);
export default default_1;